import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()

export class ResetpasswordService extends ServiceGlobal {
    email: string;
    temporary_password: string;
    new_password: string;
    confirm_password: string;

    tableName() { return 'user'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            email : 'Email',
            temporary_password : 'Temporary Password',
            new_password: 'New Password',
            old_password: 'Old Password',
            confirm_password: 'Confirm new password',
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "email": {
              "type": "string",
              "require": {
                "empty": true,
              },
            },
            "temporary_password": {
              "type": "string",
              "require": {
                "empty": true,
                "size": 100
              },
            },
            "new_password": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                    "password": true
                },
            },
            "confirm_password": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                    "password": true,
                    "same": {
                        "attribute": "new_password"
                    }
                },
            },
        });
    }

    resetPassword() {
        let attrs = this.getAttributesNotEmpty();
        let data_post = {
            "old": {
                "password": attrs['temporary_password']
            },
            "new": {
                "password": attrs['new_password']
            }
        };
        let api = API.RESETPASSWORD;
        api = api.replace('{email_address}', attrs['email'].trim());

        return this._db.putWithClientCredentialAuth(api, data_post).then(res => {
          return Promise.resolve(res);
        });
    }

    check_token(access_token) {
        return this._db.get(API.CHECK_TOKEN_RESET.replace('{access_token}', access_token)).then(res => {
            return Promise.resolve(res);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/resetpassword.service.ts